import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../constants/queryKeys'
import { getCancelWarning } from '../../api/operation'

function useGetCancelWarning(id?: string, enabled = true) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_OPERATION_CANCEL_WARNING, id],
      queryFn: () => {
         return getCancelWarning(id as string)
      },
      enabled: enabled && !!id,
      retry: 0,
      refetchOnWindowFocus: false,
   })
}
export { useGetCancelWarning }
export default useGetCancelWarning
